<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveActionType()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center">
              <b>Type</b>
            </div>
            <div class="col-8">
              <input type="text" class="form-control mt-2" formControlName="actionType" />
              <app-validation-message [form]="form" [path]="'actionType'" [label]="'Type'"></app-validation-message>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center">
            </div>
            <div class="col-8">
              <p-checkbox formControlName="archived" [binary]="true"></p-checkbox>
              <b style="margin-left: 2px;">Archived</b>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col text-left pl-0">
        <i class="material-icons rotate text-muted" *ngIf="disableButtons">loop</i>
        <button class="btn btn-danger ml-2" *ngIf="actionTypeId > 0" type="submit" (click)="deleteActionType()" [disabled]="disableButtons">Delete</button>
        <button class="btn btn-secondary ml-2" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="saveActionType()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
